<template>
  <div :class="showNewUi ? 'new-cart-item' : 'cart-item'" class="row">
    <div
      :class="discount ? 'col-8' : 'col-9'"
      class="item-details item-details-name"
    >
      <div
        v-show="!showNewUi && !cartItem.reedemptionRule"
        class="inline-group input-group"
      >
        <div v-if="removeButton" class="input-group-prepend">
          <button
            :disabled="isDisabled"
            class="btn btn-outline-secondary btn-minus"
            @click="stepdown"
          >
            <i class="fa fa-minus" :style="mobileStyles.textColour"></i>
          </button>
        </div>
        <input
          @change="updateQt($event)"
          ref="quantity"
          class="form-control quantity"
          min="1"
          name="quantity"
          :value="cartItem.quantity"
          type="number"
          readonly
        />
        <div class="input-group-append">
          <button
            v-if="removeButton"
            @click="stepup"
            class="btn btn-outline-secondary btn-plus"
          >
            <i class="fa fa-plus" :style="mobileStyles.textColour"></i>
          </button>
        </div>
        <div class="cart-qty-empty" v-if="cartItem.reedemptionRule"></div>
      </div>

      <div
        v-show="cartItem.reedemptionRule"
        class="cart-qty-empty-mobile"
      ></div>
      <span
        :class="cartItem.unavailable ? 'text-line-through' : ''"
        :style="showNewUi && 'font-weight : normal'"
        class="d-flex"
      >
        {{ cartItem.name }}
      </span>
      <!--      <div v-if="!showNewUi" v-show="!cartItem.reedemptionRule" class="inline-group input-group">-->
      <!--        <div class="input-group-prepend">-->
      <!--          <button-->
      <!--              :disabled="isDisabled"-->
      <!--              class="btn btn-outline-secondary btn-minus"-->
      <!--              @click="stepdown"-->
      <!--          >-->
      <!--            <i :style="mobileStyles.textColour" class="fa fa-minus"></i>-->
      <!--          </button>-->
      <!--        </div>-->
      <!--        <input-->
      <!--            ref="quantity"-->
      <!--            :value="cartItem.quantity"-->
      <!--            class="form-control quantity"-->
      <!--            min="1"-->
      <!--            name="quantity"-->
      <!--            readonly-->
      <!--            type="number"-->
      <!--            @change="updateQt($event)"-->
      <!--        />-->
      <!--        <div class="input-group-append">-->
      <!--          <button class="btn btn-outline-secondary btn-plus" @click="stepup">-->
      <!--            <i :style="mobileStyles.textColour" class="fa fa-plus"></i>-->
      <!--          </button>-->
      <!--        </div>-->
      <!--        <div v-if="cartItem.reedemptionRule" class="cart-qty-empty"></div>-->
      <!--      </div>-->
      <small v-show="!showNewUi" v-if="cartItem.modifiers || this.removeButton">
        <template
          v-for="(md, index) in flatCartItemModifiers(
            cartItem.modifiers ? cartItem.modifiers : []
          )"
        >
          {{ md.Name }}({{ md.quantity }})
          <template v-if="cartItem.modifiers.length > index + 1">,</template>
        </template>
        <div :style="mobileStyles.textColour">{{ cartItem.itemNote }}</div>

        <div>
          <a
            v-if="!cartItem.unavailable"
            href="#"
            :style="mobileStyles.LinkColorTxt"
            @click.prevent="removeCartItem(cartItem)"
            >{{ $t("message.remove") }}</a
          >
          <span class="soldout" v-if="cartItem.soldout"
            >({{ $t("message.soldOut") }})</span
          >
          <span class="soldout" v-if="cartItem.unavailable"
            >({{ $t("message.unavailable") }})</span
          >
        </div>
      </small>

      <small v-show="showNewUi" style="margin-left: 2px; max-width: 40vw">
        <template
          v-for="(md, index) in flatCartItemModifiers(
            cartItem.modifiers ? cartItem.modifiers : []
          )"
        >
          {{ md.Name }}({{ md.quantity }})
          <template v-if="cartItem.modifiers.length > index + 1">,</template>
        </template>
        <div :style="mobileStyles.textColour">{{ cartItem.itemNote }}</div>

        <div>
          <a
            v-if="!showNewUi && !cartItem.unavailable && this.removeButton"
            :style="mobileStyles.LinkColorTxt"
            href="#"
            @click.prevent="removeCartItem(cartItem)"
            >{{ $t("message.remove") }}</a
          >
          <span class="soldout" v-if="cartItem.soldout"
            >({{ $t("message.soldOut") }})</span
          >
          <span class="soldout" v-if="cartItem.unavailable"
            >({{ $t("message.unavailable") }})</span
          >
        </div>
      </small>
    </div>

    <div
      v-if="!discount"
      class="col-3 item-price"
      :class="cartItem.unavailable ? 'text-line-through' : ''"
    >
      <div>{{ price | formatMoney(currencySign) }}</div>
      <div
        v-if="getPoints"
        class="item-points text-success"
        v-show="this.applicableLoyalityRule.length === 1"
      >
        <span v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) || enableStamps">
          ({{ Math.floor(getPoints) | formatNumber }}
          {{ loyaltyUnit(Math.floor(getPoints)) }})
        </span>
      </div>
    </div>

    <div
      class="col-4 item-price"
      v-else
      :class="cartItem.unavailable ? 'text-line-through' : ''"
    >
      <del class="fs-75 pr-2">{{ price | formatMoney(currencySign) }}</del>
      <span>{{ discount | formatMoney(currencySign) }}</span>
      <div v-if="getPoints" class="item-points text-success">
        <span v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) || enableStamps">
          ({{ Math.floor(getPoints) | formatNumber }}
          {{ loyaltyUnit(Math.floor(getPoints)) }})
        </span>
      </div>
    </div>

    <div v-if="rollInto" class="col-md-12">
      <div v-for="rt in rollInto.selectedRollIntos" :key="rt.ID">
        <a
          class="run-into-meal-btn row"
          @click="editRollInto(rt)"
          :style="rollIntoButtonClassNames(rt)"
        >
          <div class="col-9 item-details item-details-name roll-into-mobile">
            <span class="d-flex roll-into-mobile-name">{{
              rollInto.Name | camelCase
            }}</span>
            <small
              v-if="rt.selectedModifiers"
              :style="mobileStyles.primaryColor"
            >
              <template v-for="(md, index) in rt.selectedModifiers">
                {{ md.Name }}({{ md.quantity }})
                <template v-if="rt.selectedModifiers.length > index + 1"
                  >,</template
                >
              </template>
            </small>
          </div>
          <div class="col-3 item-price">
            {{ rt.appliedDiscount | formatMoney(currencySign) }}
          </div>
        </a>
        <div v-if="getRollIntoPoints(rt)" class="roll-item-point">
          ({{ Math.floor(getRollIntoPoints(rt)) | formatNumber }} pts)
        </div>
      </div>
    </div>

    <div v-if="showRollInto" class="m-rollinto-popup" :style="styles.pageColor">
      <Modifiers
        :from-shopping-cart="true"
        :has-confirm-button="true"
        :initial-modifiers="initialModifier(selectedIndex)"
        :is-submodifier="true"
        :modifiers="rollIntoParams.modifiers"
        :price-trigger="rollInto"
        :product="rollIntoParams.product"
        :product-id="rollIntoParams.productId"
        :rollinto-index="selectedIndex"
        @canceled="showRollInto = false"
        @updated="selectRollIntoModiefiers"
      />
    </div>

    <div
      v-if="showNewUi"
      v-show="!cartItem.reedemptionRule"
      class="container-fluid d-flex justify-content-between align-items-center"
    >
      <div class="d-flex justify-content-start">
        <div v-if="removeButton" class="input-group-prepend">
          <button
            :disabled="isDisabled"
            class="btn btn-minus mr-1 mt-3 quantity-button"
            @click="stepdown"
          >
            <i :style="mobileStyles.textColour" class="fa fa-minus"></i>
          </button>
        </div>
        <div
          class="mt-3"
          style="
            width: 30px;
            height: 30px;
            border-radius: 8px;
            margin-left: 0.4em;
            margin-right: 0.4em;
            padding: 0;
            background-color: #fff;
          "
        >
          <p class="p-2">{{ cartItem.quantity }}</p>
        </div>
        <div v-if="removeButton" class="input-group-append">
          <button
            class="btn btn-minus mr-1 mt-3 quantity-button"
            @click="stepup"
          >
            <i :style="mobileStyles.textColour" class="fa fa-plus"></i>
          </button>
        </div>
        <div v-if="cartItem.reedemptionRule" class="cart-qty-empty"></div>
      </div>
      <div v-if="removeButton">
        <button
          v-if="!cartItem.unavailable"
          class="btn btn-minus mr-1 mt-3 delete-button"
          @click.prevent="removeCartItem(cartItem)"
        >
          <i :style="mobileStyles.textColour" class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.quantity-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  padding: 0;
  background-color: #f8f8f8;
  font-size: 1rem;
}

.delete-button {
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  font-size: 22px !important;
  color: #ef6565;
}
</style>

<script>
import shared from "../../../sharedscripts/shop/shopping-cart/CartItem.js";
import { priceTriggerType } from "../../../api/constants/priceTriggerEnums";
import Modifiers from "../products/Modifiers";
import { mapGetters } from "vuex";

export default {
  components: { Modifiers },
  props: {
    cartItem: {
      type: Object,
      default: () => {},
    },
    removeButton: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      qtyNumbers: [],
      showRollInto: false,
      selectedRollIntoModiefiers: [],
    };
  },
  watch: {
    "cartItem.quantity": function () {
      if (this.rollInto) {
        this.fixRollIntoQuantity();
      }
    },
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "styles",
      "mobileStyles",
      "storeMenu",
      "getPriceTriggerOutcomes",
      "canshowRollInto",
      "applicableLoyalityRule",
      "showNewUi",
      "viewConfig",
    ]),
    isDisabled() {
      return this.cartItem.quantity == 1;
    },
    showRollIntoProduct() {
      if (this.rollInto)
        return this.canshowRollInto({
          ...this.menuCopy.Products[this.cartItem.id],
          quantity: this.cartItem.quantity,
          index: this.rollInto.selectedRollIntos.length,
        });
      return null;
    },
    rollInto() {
      var result = this.getPriceTriggerOutcomes.find(
        (oc) =>
          oc.order == this.cartItem.uniqueId &&
          oc.type == priceTriggerType.rollIntoMealPriceTriggers
      );
      if (result && !result.selectedRollIntos) result.selectedRollIntos = [];
      return result;
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      return {
        product:
          this.menuCopy.Products[this.rollInto.rollIntoProduct.ProductID],
        modifiers: this.menuCopy.ModifierGroups,
        productId: this.rollInto.rollIntoProduct.ProductID,
      };
    },
  },
  created() {
    shared.createdComponent(this);
  },
  methods: {
    ...shared.methods,
    stepup() {
      this.$refs.quantity.stepUp();
      this.updateQt(this.$refs.quantity.value);
    },
    stepdown() {
      this.$refs.quantity.stepDown();
      this.updateQt(this.$refs.quantity.value);
    },
  },
};
</script>
